import { render, staticRenderFns } from "./SearchButtons.vue?vue&type=template&id=29f2e1f2"
import script from "./SearchButtons.vue?vue&type=script&lang=js"
export * from "./SearchButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports